import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { UsgService } from '../usg.service';
import { PathologyService } from '../pathology.service';

@Component({
    selector: 'app-labreport',
    templateUrl: './labreport.component.html',
    styleUrls: ['./labreport.component.scss'],
    standalone: false
})
export class LabreportComponent implements OnInit {
  pdfLoading= false;
  pdf;
  @Input ('pdf') pddData: any;
  @Input('reportid') reportid: number;
  @Input ('inventoryId') inventoryId: number;
  @Output('closed') closed = new EventEmitter<boolean>();

  @Input('assignable') assignable: boolean = false;
  selectedPathology: number | null = null;

  constructor(private sanitizer: DomSanitizer, private gastroService: UsgService, private pathologyService: PathologyService) { }

  ngOnInit(): void {
    
    if (this.reportid) {
      this.openLabResults(this.reportid);
    }
    else if (this.pddData) {
      let file = new Blob([this.pddData], {type: 'application/pdf'});
      this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file));
    }
    else if (this.inventoryId) {
      this.openInventoryReport(this.inventoryId);
    }
  }

    openLabResults(resultid){
    this.pdfLoading = true;
    this.gastroService.getLabResultPdf(resultid).subscribe((data:any)=>{
      let file = new Blob([data], {type: 'application/pdf'});
      this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file));
      this.pdfLoading = false;
    }, error => {
      console.error('Error fetching lab results PDF:', error);
      this.pdfLoading = false;
    });
  }

  openInventoryReport(inventoryId){
    this.pdfLoading = true;
    this.gastroService.getInventoryReportPdf(inventoryId).subscribe((data:any)=>{
      //data comes as a binary array buffer
      let file = new Blob([data], {type: 'application/pdf'});
      this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file));
      this.pdfLoading = false;
    }, error => {
      console.error('Error fetching inventory report PDF:', error);
      this.pdfLoading = false;
    });
  }

  assignToExam(){
      this.pathologyService.assignLabReportToExam(this.reportid).subscribe(() => {
        this.closed.emit(true);
      }, error => {
        console.error('Error assigning lab report to pathology:', error);
      });
    }
}
